import { snapshot } from 'valtio'
import { endOfDay, formatISO, startOfDay } from 'date-fns'
import { DEFAULT_LIMIT, buildAxiosInstance } from '../utils/apiUtils'
import { type TransactionType } from '../types/GlobalTranactionTypeEnum'
import { transactionsProxy } from '../proxies/transactionsProxy'
import { convertFromCentValue } from '../utils/formattingUtils'
import { type GlobalTransactionHisType } from '../types/GlobalTransactionHisType'

const buildfetchParams = (): { [key in string]: string | number | null | readonly TransactionType[] } => {
  const { filters, pagination } = snapshot(transactionsProxy)
  const params: { [key in string]: string | number | null | readonly TransactionType[] } = {
    limit: pagination.limit ?? DEFAULT_LIMIT,
    offset: filters.offset
  }
  if (filters.startDate) {
    params.startDate = formatISO(startOfDay(filters.startDate), { representation: 'complete' })
  }
  if (filters.endDate) {
    params.endDate = formatISO(endOfDay(filters.endDate), { representation: 'complete' })
  }

  if (filters.search) {
    params.search = filters.search
  }

  if (filters.sortColumn && filters.sortDirection) {
    params.sortColumn = filters.sortColumn
    params.sortDirection = filters.sortDirection
  }

  if (filters.transactionTypes && filters.transactionTypes.length > 0) {
    params.sslTransactionTypes = [...filters.transactionTypes]
  }

  //we want to ignore transactions from recurring payments...BC
  params.recurringPaymentId = null

  return params
}

interface Args {
  displayLoader: boolean
  ignoreRecords?: boolean
}

export async function executeTransactionsSearch ({ displayLoader = true, ignoreRecords = false }: Args): Promise<void> {
  if (displayLoader) { transactionsProxy.apiCall.loading = true }
  transactionsProxy.apiCall.error = null
  try {
    const params = buildfetchParams()
    const response = await buildAxiosInstance().post('/api/transactions/search', params)
    if (response.data.error) {
      transactionsProxy.apiCall.error = response.data.error
      return
    }
    const recentT = response.data?.data?.transactions ?? []
    recentT.forEach((txn: GlobalTransactionHisType) => {
      txn.amountCents = convertFromCentValue(txn.amountCents, txn.amountCurrencyType)
      txn.remainingAmountCents = convertFromCentValue(txn.remainingAmountCents, txn.remainingAmountCurrencyType)
    })

    if (ignoreRecords) {
      //don't change the existing table at all but instead put the records on a different property
      transactionsProxy.exportTransactions = recentT
    } else {
      transactionsProxy.transactions = recentT
    }
    transactionsProxy.pagination = response.data.data.pagination
  } catch (e) {
    if (e instanceof Error) {
      transactionsProxy.apiCall.error = e.message
    }
  } finally {
    if (displayLoader) { transactionsProxy.apiCall.loading = false }
  }
}
